import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { capitalize } from '@material-ui/core';

const styles = () => ({
  root: {},
  checkboxRoot: {}, // Does not exist in Material UI FormControlLabel
});

const MUI_COLORS = [
  'primary',
  'secondary',
  'default',
];

export const COLORS = [
  ...MUI_COLORS,
  'white',
];

const getColorProp = (color) => {
  if (COLORS.includes(color)) {
    return color;
  }
  return 'default';
};

const getRootColor = (color) => {
  return {
    color,
  };
};

const getCheckboxColor = (color) => {
  return {
    color,
  };
};

const useCustomStyles = makeStyles(theme => ({
  rootColorPrimary: {},
  rootColorSecondary: {},
  rootColorWhite: getRootColor(theme.palette.common.white),
  checkboxColorPrimary: {},
  checkboxColorSecondary: {},
  checkboxColorWhite: getCheckboxColor(theme.palette.common.white),
}));

const CheckListOption = ({
  className,
  classes,
  value,
  onChange,
  label,
  color,
  isChecked,
}) => {
  const {
    checkboxRoot: checkboxRootClass,
    root: rootClass,
    ...restClasses
  } = classes;
  const customClasses = useCustomStyles();
  return (
    <FormControlLabel
      classes={{
        root: classNames(classes.root, className, customClasses[`rootColor${capitalize(color)}`]),
        ...restClasses,
      }}
      value={value}
      control={
        <Checkbox
          checked={isChecked}
          name={value}
          onChange={onChange}
          color={getColorProp(color)}
          classes={{
            root: classNames(checkboxRootClass, customClasses[`checkboxColor${capitalize(color)}`]),
          }}
        />
      }
      label={label}
    />
  );
};

CheckListOption.defaultProps = {
  className: '',
};

CheckListOption.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.oneOf(COLORS).isRequired,
  isChecked: PropTypes.bool.isRequired,
};

export default withStyles(styles)(CheckListOption);
